import AdminLayout from "../../components/admin/AdminLayout";
import AdminAssessments from "../../components/AdminAssessments";

export default function AdminAssessmentsPage() {
  return (
    <AdminLayout title="Assessment Submissions" subtitle="Operations Readiness Assessment leads and scores.">
      <AdminAssessments />
    </AdminLayout>
  );
}
